module.exports = "/images/img_landing_icon_v2.png?e7b46654f88c0b71ea608f5028d91a7f";